import { Component, OnInit } from '@angular/core';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-assigned-resume',
  templateUrl: './assigned-resume.component.html',
  styleUrls: ['./assigned-resume.component.scss']
})
export class AssignedResumeComponent implements OnInit {

  
  showDetails: boolean = false;
  panelOpenState = false;
  activeTab = 0;

  resumeHide:boolean=true;
  attemptHide01:boolean=false;
  attemptHide02:boolean=false;
  attemptHide03:boolean=false;
  contactHide:boolean=false;
  resetSentHide:boolean=false;
  hideBtn:boolean=false;
  lockedhideBtn:boolean=true;
  completedhideBtn:boolean=false;
  hidestartBtn:boolean=false;

resumeClick(){
    this.attemptHide01=true;
    this.resumeHide=false;
    this.attemptHide02=false;
    this.attemptHide03=false;
    this.contactHide=false;
    this.resetSentHide=false;
}
attempt01(){
  this.resumeHide=false;
  this.attemptHide02=true;
  this.attemptHide01=false;
  this.attemptHide03=false;
  this.contactHide=false;
  this.resetSentHide=false;
}
attempt02(){
  this.attemptHide03=true;
  this.attemptHide02=false;
  this.attemptHide01=false;
  this.resumeHide=false;
  this.contactHide=false;
  this.resetSentHide=false;
}
attempt03(){
  this.attemptHide01=false;
  this.attemptHide02=false;
  this.attemptHide03=false;
  this.resumeHide=false;
  this.contactHide=true;
  this.resetSentHide=false;
}
contactClick(){
  this.attemptHide01=false;
  this.attemptHide02=false;
  this.attemptHide03=false;
  this.resumeHide=false;
  this.contactHide=false;
  this.resetSentHide=true;
}

resetSentClick(){
  this.attemptHide01=false;
  this.attemptHide02=false;
  this.attemptHide03=false;
  this.resumeHide=false;
  this.contactHide=false;
  this.resetSentHide=false;
  this.hideBtn=true;
  this.lockedhideBtn=false;
  this.hidestartBtn=true;
}

startBook(){
  this.hidestartBtn=false;
  this.completedhideBtn=true;
}
 
  showDetailsEvent() {
    this.showDetails = !this.showDetails;       
    }
  ngOnInit(): void {
   

  }
  closeResult = '';

  constructor(private modalService: NgbModal) {}

  open(content: any) {
    this.modalService.open(content, { centered: true, size: 'sm' });
  }

}
